/**
 * Table search over several fields (legacy BaseTable `filterByMultipleKeys`, B772): a row matches when any field's text
 * contains the term, ignoring case, even a single letter ("o" finds "Comp Drink"). An empty field, 0 included, never
 * matches, as legacy's `obj[key] &&`. The term is trimmed, as every legacy search box binds it with v-model.trim, and a
 * blank term matches every row. Legacy used the term as a regular expression; here it is literal, so "(" or "a.b" mean
 * themselves (B759).
 * Single-field tables keep `legacySearchMatches` (one letter matches word initials there, as legacy).
 */
export function legacyFieldsSearchMatches(term: string, fields: readonly (string | number | null | undefined)[]): boolean {
  const needle = term.trim().toLowerCase();
  if (needle === '') return true;
  return fields.some((field) => Boolean(field) && String(field).toLowerCase().includes(needle));
}
